module.exports = __webpack_public_path__ + "static/media/Empty-Search.88107918.svg";